export const COLLAPSED_REPORT_ITEMS_LIMIT = 3
